export default function Guarantee() {
  const { profile } = useCtx('userId')
  const t = useI18n()
  const { stylist, name } = profile

  if (!stylist.isGuarantee) return ''

  return (
    <div className='container border-t py-5'>
      <div className='flex items-start space-x-2'>
        <div>
          <div className='font-medium line-clamp-1 text-[1.1rem]'>{ t('page:styleId.guaranteeTitle', { name, interpolation: { escapeValue: false } }) }</div>
          <div className='text-sm text-gray-600 py-2'>{ t('page:styleId.guaranteeDesc') }</div>
          <div onClick={ () => h.openGuaranteeDetail() } className='cursor-pointer underline text-sm font-medium'>{ t('page:styleId.readMore') }</div>
        </div>
        <div className='pt-3'>
          <C.Image src={ cdn('images/badge/guarantee256.png') } className='w-14 h-14' alt=''/>
        </div>
      </div>
    </div>
  )
}
